import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Loader } from 'wix-style-react';
import s from './CorvidPage.scss';

let iframe;

class CorvidPage extends React.Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    biLogger: PropTypes.func.isRequired,
  };

  iframe;

  constructor(props) {
    super(props);
    this.state = {
      iframeLoaded: false,
      lightboxOverlay: false,
    };
  }

  iframePostHandler() {
    window.addEventListener('message', (event) => {
      if (event.data.keyManagerEvent) {
        const { type, payload = {} } = event.data.keyManagerEvent;
        switch (type) {
          case 'PAGE_READY':
            // Wix Page is Ready
            this.setState({ iframeLoaded: true });
            break;

          case 'OPEN_LIGHTBOX_OVERLAY':
            this.setState({ lightboxOverlay: true });
            break;
          case 'CLOSE_LIGHTBOX_OVERLAY':
            this.setState({ lightboxOverlay: false });
            break;
          case 'BI_EVENT':
            this.props.biLogger.log(payload);
          // eslint-disable-next-line no-fallthrough
          default:
            break;
        }
      }
    });
  }

  componentDidMount() {
    // Note: you might want to invoke notify after initial data fetch (to keep BM loader during fetch)
    this.iframePostHandler();
  }

  render() {
    const { iframeLoaded } = this.state;
    const { url } = this.props;
    return (
      <div id="corvid-page">
        {this.state.lightboxOverlay ? <div className={s.overlay} /> : ''}
        {!iframeLoaded && (
          <div className={s.loader}>
            <Loader size="large" text={'loading'} />
          </div>
        )}
        <div id="iframeContainer" className={s.iframeContainer}>
          <iframe
            className={`${s.iframe} ${iframeLoaded ? s.iframeVisible : ''}`}
            data-hook="secrets-manager-page-iframe"
            title="corvid page"
            src={url}
            width={this.props.width}
            height={this.props.height}
            ref={(e) => (iframe = e)}
          />
        </div>
      </div>
    );
  }
}

export default translate(null, { wait: true })(CorvidPage);
